import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const IMG_1 = "https://images.pexels.com/photos/2255935/pexels-photo-2255935.jpeg?auto=compress&cs=tinysrgb&w=1200";
const IMG_2 = "https://images.pexels.com/photos/6231819/pexels-photo-6231819.jpeg?auto=compress&cs=tinysrgb&w=1200";
const IMG_3 = "https://images.pexels.com/photos/5691686/pexels-photo-5691686.jpeg?auto=compress&cs=tinysrgb&w=1200";

export default function AboutPage() {
  return (
    <div data-testid="about-page" className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16 sm:py-24">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-7">
          <div className="text-xs uppercase tracking-[0.28em] font-semibold text-[#D35400]">About</div>
          <h1 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-semibold text-[#1A2E24]">
            A small Berlin office
            <br />with a very specific job.
          </h1>
          <p className="mt-8 text-[#5C6B64] leading-relaxed max-w-2xl">
            Tool Cool Farm & Homestead Experts was started by a group of Berliners who moved to the
            United States on contract work — and were shocked by how brutal the process was. Bad
            agencies, missing paperwork, no housing, no plan. We built the company we wish we had.
          </p>
          <p className="mt-4 text-[#5C6B64] leading-relaxed max-w-2xl">
            Today we operate from a small Torstraße office in Mitte, Berlin. Every contractor we
            place gets a real farm, a real team overseas, and a Berlin advocate who stays in the
            loop long after the wheels touch down at JFK or DFW.
          </p>
        </div>
        <div className="lg:col-span-5 relative aspect-[4/5] overflow-hidden border border-[#DCD7C9]">
          <img src={IMG_1} alt="Berlin" className="h-full w-full object-cover" />
        </div>
      </div>

      {/* Values */}
      <div className="mt-24 grid grid-cols-1 md:grid-cols-3 gap-6">
        {[
          { t: "Berlin honest", b: "We say what we mean. Contracts have real numbers, real dates, real names." },
          { t: "Craft-first", b: "We only place skilled trades: farming, homesteading, construction, rural tech." },
          { t: "Long-term", b: "We stay in touch after your move. You're not a placement — you're the network." },
        ].map((v) => (
          <div key={v.t} className="border border-[#DCD7C9] bg-white p-8">
            <div className="font-display text-2xl text-[#1A2E24]">{v.t}</div>
            <div className="mt-3 text-sm text-[#5C6B64] leading-relaxed">{v.b}</div>
          </div>
        ))}
      </div>

      {/* Image strip */}
      <div className="mt-24 grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="relative aspect-[4/3] overflow-hidden border border-[#DCD7C9]"><img src={IMG_2} alt="Team" className="h-full w-full object-cover"/></div>
        <div className="relative aspect-[4/3] overflow-hidden border border-[#DCD7C9]"><img src={IMG_3} alt="Farm" className="h-full w-full object-cover"/></div>
      </div>

      <div className="mt-24 flex justify-between items-end gap-8 border-t border-[#DCD7C9] pt-12">
        <div>
          <div className="font-display text-3xl text-[#1A2E24]">Ready to be placed?</div>
          <p className="mt-2 text-[#5C6B64]">Join the network and we'll match you to a US farm with a team you'll actually like.</p>
        </div>
        <Link data-testid="about-cta" to="/signup" className="inline-flex items-center gap-2 bg-[#D35400] text-white px-6 py-3 text-sm font-medium hover:bg-[#E67E22]">
          Sign up <ArrowUpRight size={16}/>
        </Link>
      </div>
    </div>
  );
}
